(function ($) {
	// Set scrollbar width
	function setScrollbarWidth() {
		// Creating invisible container
		const outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll'; // forcing scrollbar to appear
		outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
		document.body.appendChild(outer);

		// Creating inner element and placing it in the container
		const inner = document.createElement('div');
		outer.appendChild(inner);

		// Calculating difference between container's full width and the child width
		const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

		// Removing temporary elements from the DOM
		outer.parentNode.removeChild(outer);

		$(':root').css('--scrollbar-width', `${scrollbarWidth}px`, '0px');
	}
	setScrollbarWidth();

	// GB tables
	$('.wp-block-table > table').wrap('<div class="table-wrapper"></div>');

	// Contact form (textarea)
	document.querySelectorAll('.wp-block-contact-form-7-contact-form-selector textarea').forEach(function(textarea) {
		textarea.addEventListener('input', function() {
			this.style.height = 'auto';
			this.style.height = this.scrollHeight + 2 + 'px';
		});
	});
}(jQuery));